import { Grid, Typography } from "@mui/material";
import CustomContainer from "components/common/Materialui/Container/CustomContainer";
import { muiGridContainerSpacing } from "components/common/js/constants";
import { useTranslation } from "react-i18next";

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <CustomContainer>
      <Grid
        container
        spacing={muiGridContainerSpacing}
        sx={{
          height: { md: "80vh", xs: "100vh" },
        }}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} textAlign="center">
          <Typography
            variant="h1"
            data-testid="MaintenancePage-header-testid"
            className="font-weight-bold"
            mb={4}
          >
            {t("common.maintenanceTitle")}
          </Typography>
          <Typography variant="h5" mb={2}>
            {t("common.maintenanceDescription")}
          </Typography>
        </Grid>
      </Grid>
    </CustomContainer>
  );
};

export default MaintenancePage;
